import { faHandHoldingDollar } from '@fortawesome/pro-regular-svg-icons'
import { Flex, Progress, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { CardMetric, TextCurrency } from '@flecto/ui'

type CardBookingDepositSummaryProps = {
  cents: number
  keptCents: number
  withProgressBar?: boolean
}

export function CardBookingDepositSummary({
  cents,
  keptCents,
  withProgressBar = false,
}: CardBookingDepositSummaryProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_payments' })

  const progress = (keptCents / cents) * 100

  return (
    <CardMetric>
      <CardMetric.Icon icon={faHandHoldingDollar} color='blue' />
      <CardMetric.Title>{t('card_deposit_summary_title')}</CardMetric.Title>
      <CardMetric.Value>
        <Flex align='center'>
          <TextCurrency fw={500} cents={keptCents} />{' '}
          <Text mx='xs' color='dimmed'>
            {t('card_deposit_summary_of')}{' '}
          </Text>
          <TextCurrency cents={cents} color='dimmed' />{' '}
        </Flex>
      </CardMetric.Value>
      {withProgressBar && (
        <CardMetric.Extra>
          <Progress mt='xs' value={progress} />
        </CardMetric.Extra>
      )}
    </CardMetric>
  )
}
